import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'
import React from 'react'
import { emails } from 'ui-components'
import { renderEmail } from '~email/functions/renderEmail'
const { MemberInvitation } = emails

/**
 * @preserve
 * @param {SendMemberInvitation} params
 */
const sendMemberInvitation = async (params) => {
  const { toAddresses, workspace } = params || {}
  const content = renderEmail(<MemberInvitation workspace={workspace} />)
  const { data, errors } = await API.graphql({
    query: SEND_EMAIL_MUTATION,
    variables: {
      input: {
        to: toAddresses,
        subject: 'Do you want to join my workspace?',
        content
      }
    }
  })
  if (errors?.length) throw errors
  return data?.sendEmail
}

export { sendMemberInvitation }

const SEND_EMAIL_MUTATION = gql`
  mutation SendEmail($input: SendEmailInput!) {
    sendEmail(input: $input)
  }
`

/**
 * @preserve
 * @typedef {Object} SendMemberInvitation
 * @property {string[]} toAddresses
 * @property {object} workspace
 */
